import { useRef, useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { AutoComplete } from 'primereact/autocomplete';

import EstaSeguro from "../../components/alertas/esta-seguro.js";
import logo from "../../assets/logos/TRANSKYRIOS-_IconColor.avif";
import ContactoTI from "../../components/contacto-ti/contacto-ti.js";
import ModuleLayout from '../../layouts/layout-modulo.js';

import { obtenerUsuarios } from '../../services/personasService.js';
import { restablecerContrasena } from '../../services/personasService.js';

import './gestion-personas.css'

function RestablecerContrasena() {
  const toast = useRef(null);  
  const navigate = useNavigate();
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [usuarios, setUsuarios] = useState([]);
  const [filteredUsuarios, setFilteredUsuarios] = useState([]);
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(null);

  // Obtener usuarios registrados vigentes en el sistema
  const getUsuarios = useCallback(async () => {
    try {
      const response = await obtenerUsuarios();
      const lista = (response.usuarios || []).map(u => ({ ...u, display: `${u.nombre} (${u.email})`
      // Display es el texto que se mostrara al seleccionar el usuario.
    }));

      setUsuarios(lista || []);

    } catch (error) {
      toast.current?.show({ 
        severity: 'error', summary: 'Error', life: 3500,
        detail: error || 'Error al cargar los usuarios.'
      });
    }
  }, []);

  useEffect(() => { getUsuarios(); }, [getUsuarios]);

  // Buscar un usuario del listado
  const searchUsuarios = (event) => {
    const query = event.query.trim().toLowerCase();

    setFilteredUsuarios(
        !query
            ? usuarios
            : usuarios.filter((u) =>
                u.display.toLowerCase().includes(query)
            )
    );
  };

  // Cambiar de usuario
  const handleUsuarioChange = (e) => {
    setUsuarioSeleccionado(e.value);
  };

  // Confirmar restablecer la contraseña
  const handleConfirmar = async () => {
    setIsSubmitting(true);

    try {
      if (!usuarioSeleccionado) {
        toast.current?.show({
          severity: 'warn',
          summary: 'Atención',
          detail: 'Debe seleccionar un usuario.',
          life: 3000
        });
        return;
      }

      const response = await restablecerContrasena(usuarioSeleccionado);
      if (response?.ok === false) { throw new Error('No se pudo restablecer la contraseña'); }

      setConfirmVisible(false);
      setUsuarioSeleccionado(null);

      toast.current?.show({
        severity: 'success',
        summary: 'Éxito',
        detail: 'La contraseña ha sido restablecida correctamente.',
        life: 3500
      });

    } catch (error) {
      console.error(error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Error al restablecer la contraseña.',
        life: 3000
      });
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <ModuleLayout titulo="Gestión de Personas" logo={logo} onVolver={() => navigate('/app')}>
      <Toast ref={toast} position="center" />

      <section className="tmc-content">
        <h3 className='titulo-form'>Restablecer contraseña</h3>
        <section className="form-section">
          <form className="container-form">
            <div className='card-nc'>

              <div class="alert alert-info" role="alert">
                <b>Nota:</b> Al restablecer la contraseña, se enviará un email al usuario con sus nuevas credenciales.
              </div>

              <div className="form-comprobante-field">
                <label className="form-label">
                  Nombre del usuario<span className="required">*</span>
                </label>

                <AutoComplete
                  value={usuarioSeleccionado}
                  suggestions={filteredUsuarios}
                  completeMethod={searchUsuarios}
                  onChange={handleUsuarioChange}
                  forceSelection
                  placeholder="Buscar usuario..."
                  field="display"
                  className="w-100"
                  inputClassName="w-100"
                  itemTemplate={(u) => (
                    <div>
                      <div><b>{u.nombre}</b></div>
                      <small className="text-muted">{u.email}</small>
                    </div>
                  )}
                />
              </div>
              
              <div className='tmc-btns-container mt-5'>
                <Button type="button" label="Restablecer" icon="pi pi-sync" 
                  className="btn btn-outline-danger" 
                  onClick={() => { setConfirmVisible(true) }}
                  disabled={isSubmitting || !usuarioSeleccionado}
                />
                <EstaSeguro
                  visible={confirmVisible}
                  onHide={() => setConfirmVisible(false)}
                  onConfirm={handleConfirmar}
                  titulo="¿Restablecer contraseña?"
                  descripcion="Esta acción enviará un correo al usuario con la nueva contraseña."
                  confirmLabel="Restablecer"
                  icon="pi pi-sync"
                  posicion="center"
                />
              </div>
            </div>
          </form>
        </section>
      </section>

      <section className="per-content">
        <ContactoTI />
      </section>
    </ModuleLayout>
  );
}

export default RestablecerContrasena